import { HStack, VStack } from 'ui_2';
import { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import { levelKgs } from '@src/data/utils';
import { BiMapPin } from 'react-icons/bi';
import { useSquashGameState } from '@src/providers/squashGameState';

// Add this interface above the component
interface Watering {
  happy: boolean;
  day: string;
}

export const Waterings = () => {
  const { activeSquash, squashHistory, squashHistoryDesc } =
    useSquashGameState();
  const [waterings, setWaterings] = useState<Watering[]>([]);

  const level = activeSquash?.onChainLevel;
  const nextLevelKg = level !== undefined ? levelKgs[level + 1] : undefined;

  const prev_days_to_show = 5;
  const daysOrder = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

  useEffect(() => {
    if (
      squashHistoryDesc === undefined ||
      squashHistory === undefined ||
      squashHistoryDesc.length === 0 ||
      squashHistory.length === 0
    ) {
      return;
    }
    const day_of_week_today = dayjs(squashHistoryDesc[0].time);
    const day_of_week_today_int = day_of_week_today.day();
    const new_array: Watering[] = [];

    if (squashHistoryDesc.length < prev_days_to_show) {
      // create new array with days_to_show - squashHistoryDesc.length padded entries
      const entries_to_fill = prev_days_to_show - squashHistoryDesc.length;
      for (let i = 0; i < entries_to_fill; i++) {
        new_array.push({
          happy: false,
          day: daysOrder[day_of_week_today_int - (entries_to_fill - i)],
        });
      }
      // console.log('new_array 1', new_array.slice());

      new_array.push(
        ...squashHistory.map((history) => ({
          happy: history.mood === 'happy',
          day: dayjs(history.time).format('ddd'),
        }))
      );
      // console.log('new_array 2', new_array.slice());
    } else {
      new_array.push(
        ...squashHistory
          .slice(squashHistory.length - prev_days_to_show, squashHistory.length)
          .map((history) => ({
            happy: history.mood === 'happy',
            day: dayjs(history.time).format('ddd'),
          }))
      );
      // console.log('new_array 3', new_array.slice());
    }

    new_array.push(
      ...Array.from({ length: prev_days_to_show - 1 }).map((_, ix) => ({
        happy: false,
        day: daysOrder[(day_of_week_today_int + ix + 1) % 7],
      }))
    );
    // console.log('new_array 4', new_array.slice());

    setWaterings(new_array);
  }, [JSON.stringify(squashHistoryDesc)]);

  return (
    <VStack className='w-full'>
      <div className='text-[12px] font-normal'>WATERINGS</div>
      <HStack className='items-center justify-between gap-4'>
        {(() => {
          let foundFirstPin = false;
          return waterings.map((watering, index) => {
            const isFutureWatering =
              index >= (squashHistoryDesc?.[0]?.mood === 'happy' ? 5 : 4);
            const projectedKg = isFutureWatering
              ? (activeSquash?.kg || 0) +
                (index - (squashHistoryDesc?.[0]?.mood === 'happy' ? 4 : 3))
              : 0;
            const wouldReachNextLevel =
              nextLevelKg !== undefined &&
              projectedKg >= nextLevelKg &&
              !foundFirstPin;

            if (wouldReachNextLevel) {
              foundFirstPin = true;
            }

            return (
              <VStack key={index} className='w-8 items-center'>
                <div className='text-[10px] font-normal text-gray-500'>
                  {watering.day}
                </div>
                <div
                  className={`relative h-4 w-4 rounded-full ${
                    watering.happy ? 'bg-squashBlue' : 'bg-gray-200'
                  }`}
                >
                  {isFutureWatering && wouldReachNextLevel && (
                    <BiMapPin
                      className='absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 text-black'
                      size={12}
                    />
                  )}
                </div>
              </VStack>
            );
          });
        })()}
      </HStack>
      <div className='mx-auto mb-4 mt-1 h-1 w-1 rounded-full bg-black' />
    </VStack>
  );
};
